import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import {
    fetchVendors,
    setPage,
    setPageSize,
    setName,
    setService,
    setSortKey, removeVendor, setInviteOpen, sendVendorInvite,
} from "./vendors.slice";
import {uuid} from "@/interfaces";
import {VendorSortKey} from "@/repositories/vendors.repository";
import {toast} from "sonner";

export function useVendors() {
    const dispatch = useAppDispatch();
    const { vendors, loading, total, filters, inviteSaving, inviteOpen, inviteError } = useAppSelector(
        (s) => s.vendors
    );

    useEffect(() => {
        dispatch(fetchVendors());
    }, [
        filters.page,
        filters.pageSize,
        filters.name,
        filters.service,
        filters.sortKey,
        filters.sortOrder,
        dispatch,
    ]);

    const unlinkVendor = async (vendorId: uuid) => {
        await dispatch(removeVendor(vendorId)).unwrap();
        dispatch(fetchVendors());
    }

    const sendInvite = async(email: string) => {
        const res = await dispatch(sendVendorInvite(email)).unwrap();

        if(res.alreadyOnboarded) {
            toast.success("Vendor has been linked successfully!");
            dispatch(fetchVendors());
        } else {
            toast.success("Vendor has been sent an invite!");
        }

        openInviteModal(false);

        return res;
    }

    const openInviteModal = (open: boolean) => dispatch(setInviteOpen(open));

    return {
        vendors,
        loading,
        total,
        page: filters.page,
        pageSize: filters.pageSize,
        name: filters.name,
        service: filters.service,
        sortKey: filters.sortKey,
        sortOrder: filters.sortOrder,
        setPage: (p: number) => dispatch(setPage(p)),
        setPageSize: (s: number) => dispatch(setPageSize(s)),
        setName: (n: string) => dispatch(setName(n)),
        setService: (svc: string) => dispatch(setService(svc)),
        setSortKey: (key: VendorSortKey) => dispatch(setSortKey(key)),
        removeVendor: unlinkVendor,

        inviteOpen,
        inviteError,
        inviteSaving,
        openInviteModal,
        sendInvite,
    };
}